<template>
    <el-form v-if="companies_list" label-position="left" label-width="0px"
             class="demo-ruleForm login-container">
        <el-form-item style="width:100%;">
            <el-button style="width:100%; margin: 5px;" v-for="company in companies_list"
                @click.prevent="loginByCompany(company.company_name, company.company_id)"
                class="login__company" :key="company.company_id" type="button" role="button">
                <span><b>{{company.company_name}}</b><br><br> ID:{{company.company_id}} </span>
        </el-button>
        </el-form-item>
    </el-form>
    <el-form v-else :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px"
             class="demo-ruleForm login-container">
        <h3 class="title">Sign In</h3>
        <el-form-item prop="account">
            <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="login"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
            <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="password"></el-input>
        </el-form-item>
        <el-checkbox v-model="checked" checked class="remember">Remember</el-checkbox>
        <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click.native.prevent="onLogin" :loading="logining">
                Login
            </el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import {requestToLogin} from '../api/api';
    import {getCompaniesList} from '../api/api';
    import {loginByCompany} from '../api/api';

    export default {
        data() {
            return {
                logining: false,
                ruleForm2: {
                    account: '',
                    checkPass: ''
                },
                rules2: {
                    account: [
                        {required: true, message: 'Login is required.', trigger: 'blur'},
                    ],
                    checkPass: [
                        {required: true, message: 'Password is required', trigger: 'blur'},
                    ]
                },
                checked: true,
                companies_list: null
            };
        },
        methods: {
            onLogin() {
                this.$refs.ruleForm2.validate((valid) => {

                    if (valid) {
                        this.logining = true;
                        const loginParams = {email: this.ruleForm2.account, password: this.ruleForm2.checkPass};
                        requestToLogin(loginParams).then(data => {
                            let {token} = data.data;

                            if (!token) {
                                this.$message({
                                    message: msg,
                                    type: 'error'
                                });
                            } else {
                                sessionStorage.setItem('token', token);
                                getCompaniesList().then(data => {
                                    this.companies_list = data.data.companies
                                }).catch(error => {
                                        this.logining = false;
                                        console.log(error);
                                        console.log(error.response);
                                    }
                                )

                            }
                        }).catch(error => {
                            this.logining = false;
                            console.log(error);
                            console.log(error.response);

                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            loginByCompany(company_name, company_id) {
                loginByCompany(company_id).then(data => {
                    sessionStorage.setItem('company_name', company_name);
                    sessionStorage.setItem('token', data.data.token);
                    this.$router.push({path: '/invoice-import'});
                }).catch(error => {
                    this.logining = false;
                    console.log(error);
                    console.log(error.response);

                });
            }
        }
    }

</script>

<style lang="scss" scoped>
    .login-container {
        /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
        -webkit-border-radius: 5px;
        border-radius: 5px;
        -moz-border-radius: 5px;
        background-clip: padding-box;
        margin: 180px auto;
        width: 350px;
        padding: 35px 35px 15px 35px;
        background: #fff;
        border: 1px solid #eaeaea;
        box-shadow: 0 0 25px #cac6c6;
        .title {
            margin: 0px auto 40px auto;
            text-align: center;
            color: #505458;
        }
        .remember {
            margin: 0px 0px 35px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// Login.vue?ce83f2be